import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import holographicVertexShader from './shaders/holographic/vertex.glsl'
import holographicFragmentShader from './shaders/holographic/fragment.glsl'


export default function DiamondMesh({ material }) {
  const meshRef = useRef()
  const materialRef = useRef()

  //Animation
  useFrame(({ clock }) => {
    const elapsedTime = clock.getElapsedTime()
    if (meshRef.current) {
      meshRef.current.rotation.y = elapsedTime * 0.5
    }

    if (materialRef.current) {
      materialRef.current.uniforms.uTime.value = elapsedTime
    }

    // option
    // meshRef.current.rotation.y += 0.01
  })


  return (
    <mesh
    ref={meshRef}
    position={[0, 3.3, 0]}
    scale={[1.4, 2.5, 1.4]}
    >
      <octahedronGeometry args={[1,0]} /> 
      <primitive
        ref={materialRef}
        attach="material"
        object={new THREE.ShaderMaterial({
          vertexShader: holographicVertexShader,
          fragmentShader: holographicFragmentShader,
          transparent: true,
          side: THREE.DoubleSide,
          depthWrite: false,
          blending: THREE.AdditiveBlending,
          uniforms: {
            uTime: { value: 0 },
            uColor: { value: new THREE.Color('#70c1ff') },
          },
        })}
      />
    </mesh>
  )
}